/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import SmyFullPopup from './SmyFullPopup';
import CustomFormList from '@/components/CustomFormList';
import ExtFieldPc from '@/components/ExtFieldPc.vue';
import { getDetailCtrlFieldColumn, saveEventDetailCtrlForm, newEventDetailCtrlForm, getEventDetailCtrlFieldColumn, getDetailCtrlCustomField, deleteEventDetailCtrlTableList } from '@/api';
export default {
  name: 'detail-control-list',
  components: {
    CustomFormList: CustomFormList,
    SmyFullPopup: SmyFullPopup,
    ViewBox: ViewBox,
    XButton: XButton,
    ExtFieldPc: ExtFieldPc
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    eventId: {
      type: String,
      default: ''
    },
    id: [Number, String],
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      postData: [],
      isEdit: false,
      tableLoading: false,
      loading: false,
      isShowComponentModal: false,
      tableList: [],
      fieldList: [],
      fieldData: [],
      pageIndex: 0,
      pageSize: 10,
      orderCount: 0,
      searchForm: {
        keyword: ''
      },
      customColumns: [],
      sysColumns: []
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      // eslint-disable-next-line
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 50 - 3.6 * fontSize;
    }
  },
  watch: {
    isShowComponentModal: function isShowComponentModal(val) {
      var _this = this;
      if (val) {
        if (!this.isEdit) {
          // 明细控件自定义表单
          getDetailCtrlCustomField({
            tmplId: this.id
          }).then(function (res) {
            if (res.success) _this.fieldList = res.data;
          });
        }
      } else {
        this.$refs.customFormList.resetFormFields(); // 重置表单验证
      }
    }
  },
  methods: {
    edit: function edit(item) {
      this.isEdit = true;
      this.fieldList = item.customField.map(function (v) {
        return Object.assign(v, {
          nodeId: item.nodeId,
          is_view: 1
        });
      });
      this.isShowComponentModal = true;
    },
    loadList: function loadList() {
      var _this2 = this;
      this.tableLoading = true;
      getEventDetailCtrlFieldColumn(_objectSpread({
        tmplId: this.id,
        eventId: this.eventId
      }, this.searchForm)).then(function (res) {
        if (res.success) {
          _this2.tableList = res.data.map(function (item) {
            var obj = {};
            obj.customField = item.customField.map(function (cfd) {
              cfd.tfname = cfd.name;
              if (cfd.type === 15) cfd.ovalue = cfd.tfvvalue ? cfd.tfvvalue : '';
              if (cfd.dropList) {
                cfd.dropList = cfd.dropList.filter(function (v) {
                  return v.state === 1;
                });
              }
              cfd.isView = 1;
              return cfd;
            });
            item.sysField.forEach(function (sys) {
              obj[sys.key] = sys.name;
            });
            return obj;
          });
        }
        _this2.tableLoading = false;
      });
    },
    deleteDetailCtrlTableList: function deleteDetailCtrlTableList(id) {
      var _this3 = this;
      this.$vux.confirm.show({
        content: i18n.tc("585"),
        // 组件除show外的属性
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          deleteEventDetailCtrlTableList({
            nodeId: id
          }).then(function (res) {
            if (res.success) {
              _this3.$vux.toast.text(i18n.tc("486"));
              _this3.loadList();
            } else {
              _this3.$Message.error(res.message || '');
            }
          });
        }
      });
    },
    submit: function submit() {
      var _this4 = this;
      if (this.fieldList.length === 0) {
        this.$vux.toast.text(i18n.tc("586"));
        return false;
      }
      // 触发表单验证
      this.$refs.customFormList.formValidate().then(function (valid) {
        if (valid) {
          _this4.loading = true;
          (_this4.isEdit ? saveEventDetailCtrlForm({
            customField: _this4.fieldData.map(function (v) {
              v.tfvvalue = v.value;
              return v;
            })
          }) : newEventDetailCtrlForm({
            tmplId: _this4.id,
            eventId: _this4.eventId,
            fvs: _this4.fieldData
          })).then(function (res) {
            setTimeout(function () {
              _this4.loading = false;
            }, 500);
            if (res.success) {
              _this4.$vux.toast.text(_this4.isEdit ? i18n.tc("587") : i18n.tc("588"));
              _this4.isShowComponentModal = false;
              _this4.loadList();
            } else {
              _this4.$Message.error(res.message || '');
            }
          });
        } else {
          _this4.$vux.toast.text(i18n.tc("589"));
        }
      });
    }
  },
  created: function created() {
    var _this5 = this;
    this.loadList();
    // 明细控件表头
    getDetailCtrlFieldColumn({
      tmplId: this.id
    }).then(function (res) {
      if (res.success) {
        var customField = res.data.customField || [];
        var sysField = res.data.sysField || [];
        _this5.customColumns = customField.map(function (item) {
          return {
            title: item.name,
            key: item.key,
            type: item.type
          };
        });
        _this5.sysColumns = sysField.map(function (item) {
          return {
            title: item.name,
            key: item.key,
            type: item.type
          };
        });
      }
    });
  }
};